import MapHelper from "./helper";

/* 
  Confidence Level indicates the quality of the geocoding result.
  https://developer.trimblemaps.com/restful-apis/appendix/glossary/
*/
const SingleSearch = (value) => {
  return fetch(
    `https://singlesearch.alk.com/WW/api/search?authToken=${MapHelper.getKey()}&query=${value}&maxResults=5&countries=${MapHelper.getCountry()}&include=Meta`
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return null;
    });
};

export const isHighAddressConfidenceLevel = (addressConfidenceLevel) => {
  /* 
  Level 1: Very High, includes exact as well as very close matches. 
  Level 2: Good match, Trust is 85%
  Level 3: Uncertain match, Trust is 50%
  Doc: https://developer.trimblemaps.com/restful-apis/appendix/glossary/
  */
  return [1, 2, 3].includes(addressConfidenceLevel);
}

export default SingleSearch;
